import { C, SectionLabel, H2, BtnOrange, wrap, scrollTo, useIsMobile } from '../styles';

const lanes = [
  {
    tag: 'New product',
    t: 'Have an idea but no drawings?',
    b: 'You know what you want to build but not how to get there. Send a photo or a rough sketch and we turn it into a real, buildable design — and an accurate quote.',
    cta: 'Start with a photo',
  },
  {
    tag: 'Parts on a deadline',
    t: 'Need custom parts made now?',
    b: 'You already have a spec or a part and a deadline to hit. Send it over and we source it across our 20+ Ontario shops — with an accurate quote in under 72 hours.',
    cta: 'Get a quote',
  },
];

export default function TwoAudiences() {
  const isMobile = useIsMobile();
  return (
    <section style={{ padding: isMobile ? '64px 0' : '88px 0', borderTop: `1px solid ${C.bdr}` }}>
      <div style={wrap}>
        <SectionLabel>Who we help</SectionLabel>
        <H2 style={{ marginBottom: isMobile ? 32 : 44 }}>Two ways in.</H2>
        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 14 }}>
          {lanes.map((l) => (
            <div key={l.t} style={{
              background: C.surf, border: `1px solid ${C.bdr}`, borderRadius: 12,
              padding: isMobile ? 28 : 40, display: 'flex', flexDirection: 'column',
              transition: 'border-color 0.2s',
            }}
              onMouseEnter={e => e.currentTarget.style.borderColor = C.orange}
              onMouseLeave={e => e.currentTarget.style.borderColor = C.bdr}
            >
              <span style={{ fontSize: 10, fontWeight: 600, letterSpacing: '0.15em', textTransform: 'uppercase', color: C.orange, marginBottom: 14 }}>{l.tag}</span>
              <h3 style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: 27, fontWeight: 700, textTransform: 'uppercase', color: C.txt, lineHeight: 1.05, marginBottom: 12 }}>{l.t}</h3>
              <p style={{ color: C.mut, fontSize: 14, lineHeight: 1.75, marginBottom: 26, flexGrow: 1 }}>{l.b}</p>
              <div>
                <BtnOrange onClick={() => scrollTo('submit')}>{l.cta}</BtnOrange>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
